module.exports = __webpack_public_path__ + "img/cardPointer.2093d2fb.png";